import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=004b5b4c&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=js"
export * from "./Usage.vue?vue&type=script&lang=js"
import style0 from "./Usage.vue?vue&type=style&index=0&id=004b5b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b5b4c",
  null
  
)

export default component.exports